export const getRegionNameById = (id, regions) => {
    const region = regions.find(r => r.id === id);
    return region && region.name ? region.name : "";
};
//# sourceMappingURL=getRegionNameById.js.map